import axios from '@/axios'
import * as types from '../../mutation-types'

export default {
    namespaced: true,

    state: {
        salaryEquations: []
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('/salaries/salaryEquation').then(({ data }) => {
                commit(types.STORE_SALARY_EQUATIONS, data);
                return data;
            })
        },

        fetchById({ commit }, { id }) {
            return axios.get(`/salaries/salaryEquation/${id}`)
        },

        create({ commit }, { jobDescriptionId, salaryLevelId, salaryAfterInstallation, salaryWhenWorking, isStatic, recompenseEquations, deductionEquations }) {
            return axios.post('/salaries/equation', { jobDescriptionId, salaryLevelId, salaryAfterInstallation, salaryWhenWorking, isStatic, recompenseEquations, deductionEquations });
        },

        update({ commit }, { id, jobDescriptionId, salaryLevelId, salaryAfterInstallation, salaryWhenWorking, isStatic, recompenseEquations, deductionEquations }) {
            return axios.put(`/salaries/salaryEquation/${id}`, { jobDescriptionId, salaryLevelId, salaryAfterInstallation, salaryWhenWorking, isStatic, recompenseEquations, deductionEquations });
        },
    },

    mutations: {
        [types.STORE_SALARY_EQUATIONS](state, salaryEquations) {
            state.salaryEquations = salaryEquations;
        }
    },

    getters: {
        getSalaryEquationById: state => id => state.salaryEquations.find(c => c.id === id)
    }
}